import React from "react";
import { v4 as uuidv4 } from "uuid";
import "./PhoneImage.css";

const PhoneImage = ({ src, id }) => {
  const altText = uuidv4();

  return (
    <div className="phone-frame">
      <img id={id} className="phone-image" src={src} alt={altText} />
    </div>
  );
};

export default PhoneImage;
